
export interface LogMessage {
  role: 'user' | 'model' | 'system';
  text: string;
  timestamp: Date;
}

export enum ConnectionState {
  DISCONNECTED = 'DISCONNECTED',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
}

export interface AudioConfig {
  sampleRate: number;
}

export interface CreditPackage {
  id: string;
  liters: number;
  price: string;
  label: string;
  description: string;
}

// Reference objects for scale calibration
export const REFERENCE_OBJECTS = {
  // Coins - International
  dime: { name: 'US Dime', sizeMm: 17.91, description: '17.91mm diameter', region: 'US', icon: '🪙' },
  quarter: { name: 'US Quarter', sizeMm: 24.26, description: '24.26mm diameter', region: 'US', icon: '🪙' },
  aus_dollar: { name: 'AU $1 Coin', sizeMm: 25.0, description: '25mm diameter', region: 'AU', icon: '🪙' },
  aus_20c: { name: 'AU 20c Coin', sizeMm: 28.5, description: '28.5mm diameter', region: 'AU', icon: '🪙' },
  euro_1: { name: '€1 Coin', sizeMm: 23.25, description: '23.25mm diameter', region: 'EU', icon: '🪙' },
  euro_50c: { name: '€0.50 Coin', sizeMm: 24.25, description: '24.25mm diameter', region: 'EU', icon: '🪙' },
  gbp_pound: { name: '£1 Coin', sizeMm: 23.43, description: '23.43mm diameter', region: 'UK', icon: '🪙' },
  gbp_50p: { name: '50p Coin', sizeMm: 27.3, description: '27.3mm diameter', region: 'UK', icon: '🪙' },

  // Welding consumables - Universal
  rod_16: { name: '1.6mm TIG Rod', sizeMm: 1.6, description: '1.6mm diameter', region: 'Universal', icon: '⚡' },
  rod_24: { name: '2.4mm TIG Rod', sizeMm: 2.4, description: '2.4mm diameter', region: 'Universal', icon: '⚡' },
  rod_32: { name: '3.2mm TIG Rod', sizeMm: 3.2, description: '3.2mm diameter', region: 'Universal', icon: '⚡' },

  // Common tools - Universal
  ruler_cm: { name: 'Ruler (1cm)', sizeMm: 10, description: '10mm = 1cm mark', region: 'Universal', icon: '📏' },
  hex_key_4: { name: '4mm Hex Key', sizeMm: 4.0, description: '4mm across flats', region: 'Universal', icon: '🔧' },
  hex_key_5: { name: '5mm Hex Key', sizeMm: 5.0, description: '5mm across flats', region: 'Universal', icon: '🔧' },
  hex_key_6: { name: '6mm Hex Key', sizeMm: 6.0, description: '6mm across flats', region: 'Universal', icon: '🔧' },
} as const;

export type ReferenceObjectKey = keyof typeof REFERENCE_OBJECTS;

// Calibration for quantitative measurements
export interface CalibrationState {
  isCalibrated: boolean;
  referenceObject: ReferenceObjectKey | null;
  pixelsPerMm: number | null;
  calibratedAt: Date | null;
}
